export function readCookie(name: string): string | undefined {
  const row = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`));
  const value = row?.slice(name.length + 1);
  if (!value) {
    return undefined;
  }
  try {
    return decodeURIComponent(value);
  } catch {
    // a cookie another system wrote with broken escaping must not stop the app from starting
    return value;
  }
}
